import React from 'react';
import styles from '../../styles/MediaText.scss';

interface MediaTextProps {
  text: string;
  invertColor?: boolean;
}
export default function MediaText(props: MediaTextProps) {
  return (
    <div
      className={`${styles.mediaText} ${styles.mediaTextFont} ${
        props.invertColor ? styles.mediaTextColor : ''
      }`}
    >
      {props.text}
    </div>
  );
}
